import React, { useState } from 'react'
import {
  RadioGroup,
  InputButton,
  Checkbox,
  Button,
  InputText,
  DatePicker,
  IconA,
  Label
} from '@pcln/horizon'
import type { DateRange } from 'react-day-picker'
import AutocompleteWrapper from '@/components/AutocompleteWrapper/AutocompleteWrapper'
import { RadioPropItems as items } from './constants'
import MultiHotelForm from './HorizonMultiHotelForm'

function onCalendarChange(dates: Date | Date[] | DateRange | undefined): void {
  // eslint-disable-next-line no-console
  console.log('clicked', dates)
}

export default function SearchForm() {
  const [hotelType, setHotelType] = useState('SH')
  const [addFlights, setAddFlights] = useState(false)
  const [addCar, setAddCar] = useState(false)
  const handleChange = (value: unknown) => {
    setHotelType(value as string)
    // eslint-disable-next-line no-console
    console.log(value)
  }

  const toggleFlights = () => setAddFlights(!addFlights)
  const toggleCar = () => setAddCar(!addCar)

  const formClasses = `search-form-container flex items-center justify-center w-full mx-auto ${
    hotelType === 'MH' ? 'multi' : 'single'
  }`

  // Add conditional class for grid container based on addFlights state
  const gridContainerClass = `grid-container ${
    addFlights ? 'with-flights' : 'without-flights'
  }`

  return (
    <div className="w-full">
      <form
        className="w-full"
        aria-label="horizon-search-form"
        // eslint-disable-next-line no-alert
        onSubmit={() => alert('submitted')}
      >
        <div className={formClasses}>
          {hotelType === 'MH' ? (
            <MultiHotelForm
              radioValue={hotelType}
              setRadioValue={setHotelType}
            />
          ) : (
            <div className={gridContainerClass}>
              <div className="radio-select row-group-1 text-nowrap">
                <RadioGroup
                  className="flex flex-row justify-start"
                  name="hotelType"
                  options={items}
                  defaultValue={items[0].value}
                  required
                  aria-labelledby="trip-type"
                  handleChange={handleChange}
                />
              </div>
              <div className="location-input grow row-group-2">
                <AutocompleteWrapper
                  searchKey="startLocation"
                  typeAheadEndpoint="hotels"
                />
              </div>
              {addFlights && (
                <InputText
                  className="flight-input grow row-group-2"
                  label="Flight"
                  isLabelHidden
                  iconLeft="search"
                  placeholder="Where from?"
                />
              )}
              <div className="date-picker grow row-group-3">
                <DatePicker
                  className="date-picker grow"
                  title="Hotels: Check-in - Check-out"
                  label="Check-in - Check-out"
                  mode="range"
                  numberOfMonths={2}
                  handleCalendarChange={onCalendarChange}
                />
              </div>

              <InputButton
                type="button"
                label="Label"
                iconLeft="person"
                isLabelHidden
                placeholder="Travelers"
                className="travelers-selection row-group-3"
              />

              <div className="pkg-deals flex flex-row items-center justify-start gap-2 text-nowrap row-group-4">
                <IconA iconName="check_circle" />
                <Label htmlFor="addFlights" className="flex items-center">
                  <Checkbox
                    id="addFlights"
                    value="addFlights"
                    name="addFlights"
                    checked={addFlights}
                    handleChange={toggleFlights}
                  />
                  <span className="ml-2">Add Flights</span>
                </Label>
                <Label htmlFor="addCar" className="flex items-center">
                  <Checkbox
                    id="addCar"
                    value="addCar"
                    name="addCar"
                    checked={addCar}
                    handleChange={toggleCar}
                  />
                  <span className="ml-2">Add Car</span>
                </Label>
              </div>
              <Button
                type="primary"
                size="lg"
                className="submit-btn w-full row-group-5"
              >
                Search
              </Button>
            </div>
          )}
        </div>
      </form>
    </div>
  )
}
